/**
 * Concatenate a list of regexes into a single regex.
 * Useful for building long patterns.
 *
 * If a string literal is passed, it will match exact strings
 * e.g. reConcat("hello.") will match "hello.", not "hello1"
 *      reConcat(/hello./) will match "hello1"
 *
 * @example
 * const regex = reConcat("http://", /(?<domain>[^/]+)/, "/"); // matches http:// followed by many characters until a /
 *
 */
export function reConcat(...regexes: (RegExp | string)[]): RegExp {
    return new RegExp(regexes.map(r => {
        if (r instanceof RegExp) {
            return r.source;
        }
        return r;
    }).join(""));
}

export const PHONE_NUMBER_REGEX = /\(?\+[0-9]{1,3}\)? ?-?[0-9]{1,3} ?-?[0-9]{3,5} ?-?[0-9]{4}( ?-?[0-9]{3})? ?(\w{1,10}\s?\d{1,6})?/g;
